export const getStatusText = (status, useAcceptedDeclined = false) => {
  switch (status) {
    case 'attended':
    case 'did_attend':
      return t('in_person_training.attendance.status.did_attend');
    case 'did_not_attend':
      return t('in_person_training.attendance.status.did_not_attend');
    case 'unconfirmed':
      return t('in_person_training.attendance.status.unconfirmed');
    case 'will_attend':
      return useAcceptedDeclined
        ? t('in_person_training.attendance.status.accepted')
        : t('in_person_training.attendance.status.will_attend');
    case 'will_not_attend':
      return useAcceptedDeclined
        ? t('in_person_training.attendance.status.declined')
        : t('in_person_training.attendance.status.will_not_attend');
    case 'awaiting_reply':
    default:
      return t('in_person_training.attendance.status.awaiting_reply');
  }
};
